import React from 'react';
import {SectionView} from '../../../models/form/SectionView';
import FormField from '../FormField';
import NonInteractiveIcon from '../NonInteractiveIcon';
import IconLock from '../../icon/IconLock';
import TicketSectionTooltip from './TicketSectionTooltip';
import FooterSectionTooltip from './FooterSectionTooltip';

type Props = {
  section: SectionView
}

export default function ReadOnlySection({
  section,
}: Props) {
  const ticketSection = section.id === 'ticket';
  const footerSection = section.id === 'footer';

  const renderFields = () => section.fields.map((field) =>
    <FormField key={field.id} field={field} url={''}
      onSwitchState={() => false}
      onDelete={() => false}
      sortable={false}
      hoverActive={false}
      withElementManagement={false}/>);

  return (
    <div className='bg-white px-4 py-5 mb-5 rounded-lg p-6'>
      <div className="grid grid-cols-12 gap-6">
        <div className="col-span-4 pt-1">
          <NonInteractiveIcon><IconLock className="text-gray-dark "/></NonInteractiveIcon>
          <span className="font-bold">{section.name}</span>
          {ticketSection && <TicketSectionTooltip/>}
          {footerSection && <FooterSectionTooltip/>}
        </div>
        <div className="col-span-7 -mt-2.5">
          {renderFields()}
        </div>
        <div className="col-span-1"/>
      </div>
    </div>
  );
}
